<template>
  <div>
    <ImsInfo ref="info" :formParams="infoBase" :opCode="opCode"></ImsInfo>
  </div>
</template>

<script>
import ImsInfo from "./ImsInfo";
import SubscriberTool from '../../util/parseFormNew/tools/subscriberTool';
import mixin from '../../../../mixin/mixin';

export default {
  name: "ImsInfoDialog",
  mixins: [mixin],
  props: {
    opCode: { type: String, default: "" },
    msgid: { type: Number, default: 0 },
    neid: { type: Number, default: 0 }
  },
  data() {
    return {
      infoBase: {
        json: "",
        formId: this.opCode + "infoBase",
        subObject: "",
        modelName: "noGroup" // modelName需要与返回请求的groupBy匹配(展示分区)
      },
      vpnid:"",
      infoUrl: "/lte/ems/subscriber/imsunms/getParamJson"
    };
  },
  methods: {
    mainHandler(data = []) {
      // data为编辑按钮传入的数据
      const $this = this;
      // let subscriberArr = null;
      let arrBase = null;
      // let bussinessMap = new Map();
      const params = {
        msgid: this.msgid,
        neid: this.neid
      }
      this.vpnid = data.vpnid;
      this.$axios.post(this.infoUrl, params).then(response => {
        // 获取模板请求
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, data);
        arrBase = resultMap.get($this.infoBase.modelName);
        $this.infoBase = arrBase;
      });
    },
    reMount() {
      this.$refs.info.reMount();
    },
    getDatas() {
      const validateReturn = this.$refs.info.validateResult();
      if (!validateReturn) {
        console.log("表单验证不通过");
        return null;
      }
      const infoMap = this.$refs.info.getDatas();
      infoMap.set("vpnid",this.vpnid);
      return this.mapToJson(infoMap);
    }
  },
  components: {
    ImsInfo
  }
};
</script>
